module.exports = __webpack_public_path__ + "static/burnetcountytexas-73973fbdca9c50fcffe06de4a3f7332b.png";